import { useState } from "react"

export default function Modal({ modalOpen, title, children, onModalClose, onModalSave, additionalClasses }) {
    const handleModalClose = () => {
        onModalClose()
    }
    const handleModalsave = (setModalOpen) => {
        onModalSave()
    }
    return (modalOpen && <div
        className="modal fade show"
        style={{
            backgroundColor: "rgba(81, 81, 81, 0.5)",
            display: "block",
        }}
    >
        <div className={`modal-dialog ${additionalClasses}`}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        {`${title}`}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleModalClose}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {children}
                    </div>
                </div>
                <div className="modal-footer p-0">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={handleModalClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleModalsave}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>)
}